import { createContext, useContext, useEffect, useState } from 'react';
import sanityClient from '../client';

const HomeContext = createContext(null);

export const HomeProvider = ({ children }) => {
    const [homeData, setHomeData] = useState(null);

    useEffect(() => {
        const fetchHomeData = async () => {
            try {
                const query = `*[_type == 'home'][0] {
                    hero {
                        backgroundImage { asset },
                        logo { asset }
                    },
                    posts[] {
                        _key,
                        heading,
                        subTitle,
                        description,
                        media { asset },
                        cta { slug, text }
                    }
                }`;
                const result = await sanityClient.fetch(query);
                setHomeData(result);
            } catch (error) {
                console.error(error);
            }
        };

        fetchHomeData();
    }, []);

    return (
        <HomeContext.Provider value={homeData}>
            {children}
        </HomeContext.Provider>
    );
};

export const useHomeData = () => useContext(HomeContext);
